<template>
  <Component
    :is="resolveComponent(`WidgetsContactFormWidget${widget.form_type}`)"
    :widget="widget"
    @submitted="track"
  />
</template>

<script lang="ts" setup>
import { useGtm } from '@gtm-support/vue-gtm'

import type { PublicContactFormWidget } from '~/service/__generated-api'
import type { Widget } from '~/types/utils'

const props = defineProps<Widget<PublicContactFormWidget>>()

const gtm = useGtm()
function track() {
  if (!gtm?.enabled()) return
  window.dataLayer?.push({
    event: 'form_send',
    form_type: props.widget.form_type
  })
}
</script>
